export const enum CODE {
  ENTER = "Enter",
  ESCAPE = "Escape",
  ARROW_LEFT = "ArrowLeft",
  ARROW_UP = "ArrowUp",
  ARROW_RIGHT = "ArrowRight",
  ARROW_DOWN = "ArrowDown",
  SPACE = "Space",
  END = "End",
  HOME = "Home"
}

export const enum KEY {
  ENTER = "Enter",
  ESCAPE = "Escape",
  ARROW_LEFT = "ArrowLeft",
  ARROW_UP = "ArrowUp",
  ARROW_RIGHT = "ArrowRight",
  ARROW_DOWN = "ArrowDown",
  END = "End",
  HOME = "Home",
  SPACE = " ",
  /**
   * @deprecated
   * Used by old browers, see https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values#whitespace_keys
   */
  SPACEBAR = "Spacebar"
}

export const enum KEY_CODE {
  ENTER = 13,
  ESCAPE = 27,
  ARROW_LEFT = 37,
  ARROW_UP = 38,
  ARROW_RIGHT = 39,
  ARROW_DOWN = 40,
  SPACE = 32,
  END = 35,
  HOME = 36
}
